import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "../../../components/forms/ConfirmForm";
import Loading from "../../../components/Loading";
import GraphQLErrors from "../../../components/GraphQLErrors";
import {cancelCommitProductPricelist} from "../../../actions/InventoryApiActions";
import {createValidationErrors, createErrors} from "../../../lib/ErrorFormatter";

class CommitProductPricelistFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    return this.props.commitProductPricelistChanges({shopId: this.props.shopId})
      .then((response) => {
        if (response.data.commitProductPricelistChanges.errors.length <= 0) {
          this.props.cancelCommitProductPricelist();
        } else {
          let errors = createValidationErrors(response.data.commitProductPricelistChanges.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelCommitProductPricelist();
  }

  render() {
    let {data} = this.props;
    if (data.loading) return <Loading />
    if (data.error) return <GraphQLErrors error={data.error} />
    console.log("hasPendingProductPricelist", data.shop.hasPendingProductPricelist);
    if (data.shop.hasPendingProductPricelist === true) {
      return (
        <Form
          message="This will update all products (not subscriptions) with any pending pricing, and update products in customer carts. Are you sure you want to proceed?"
          errors={this.state.errors}
          onSubmit={this.handleSubmit.bind(this)}
          onCancel={this.handleCancel.bind(this)}
          />
      )
    } else {
      return (
        <Form
          message="There are no pending product price changes"
          errors={this.state.errors}
          submitLabel="Submit"
          onSubmit={this.handleCancel.bind(this)}
          showCancel={false}
          />
      )      
    }
  }

}

const GET_SHOP = gql`
  query shop($shopId: ID!) {
    shop(shopId: $shopId) {
      shopId
      hasPendingProductPricelist
    }
  }
`;

const COMMIT_PRODUCT_PRICELIST_CHANGES = gql`
  mutation commitProductPricelistChanges($data: CommitProductPricelistChangesInput!) {
    commitProductPricelistChanges(input: $data) {
      errors { key message }
    }
  }
`;

const withQueries = compose(
  graphql(GET_SHOP, {
    options: (props) => ({
      fetchPolicy: "network-only",
      variables: {
        shopId: props.shopId
      }
    })
  }),
  graphql(COMMIT_PRODUCT_PRICELIST_CHANGES, {
    props: ({ mutate }) => ({
      commitProductPricelistChanges: (data) => mutate({
        variables: { data: data }
      })
    })
  })  
);

export default connect(null, {cancelCommitProductPricelist})(withQueries(CommitProductPricelistFormContainer));